exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.empty[data-v-22b0e2ed]{\r\n  width: 100%;\r\n  padding: 20px 0;\n}\nimg[data-v-22b0e2ed]{\r\n  display: block;\r\n  margin: 0 auto;\r\n  width: 120px;\n}\np[data-v-22b0e2ed]{\r\n  margin-top: 10px;\r\n  text-align: center;\n}\r\n", ""]);

// exports
